import { nameScreenDynamic } from '../../utils/variables';

/**
 * Find an .option__checkbox by its data-option value using DOM traversal
 * instead of CSS.escape (which can break attribute selectors for values with spaces).
 */
function findCheckbox(value) {
    const container = document.querySelector(`${nameScreenDynamic} .list-question`);
    if (!container) return null;
    const checkboxes = container.querySelectorAll('.option__checkbox');
    for (const cb of checkboxes) {
        if (cb.getAttribute('data-option') === value) return cb;
    }
    return null;
}

export function loadSelectoptionList(answers) {
    let list = document.querySelector(`${nameScreenDynamic} .list-question`);
    if (!list) return;
    const options = Array.isArray(answers) ? answers : [];
    const optionValues = options.map((o) => (typeof o === 'string' ? o : (o?.value ?? o?.label ?? String(o))));

    let optionList = ``;
    for (const i of optionValues) {
        optionList = optionList.concat(`
        <div class="option" data-option="${i}">
            <span class="option__name">${i}</span>
            <span class="option__checkbox" data-option="${i}">
                <i class="option__icon-check ri-check-line"></i>
            </span>
        </div>
        `);
    }

    list.insertAdjacentHTML('beforeend', optionList);
}

export function selectOption(value, isMultiSelect = false) {
    if (isMultiSelect) {
        const checkbox = findCheckbox(value);
        if (!checkbox) return;
        checkbox.classList.toggle('is-selected');

        const hasSelectedOptions = document.querySelectorAll(
            `${nameScreenDynamic} .option__checkbox.is-selected`
        ).length > 0;

        const continueBtn = document.querySelector(`${nameScreenDynamic} .selectContinue__btn`);
        if (hasSelectedOptions) {
            continueBtn.classList.remove('disabled');
        } else {
            continueBtn.classList.add('disabled');
        }
    } else {
        removeAllSelectedOption();
        const checkbox = findCheckbox(value);
        if (checkbox) checkbox.classList.add('is-selected');
        document
            .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
            .classList.remove('disabled');
    }
}

export function removeAllSelectedOption() {
    document
        .querySelectorAll(`${nameScreenDynamic} .option__checkbox`)
        .forEach((i) => i.classList.remove('is-selected'));

    document
        .querySelector(`${nameScreenDynamic} .selectContinue__btn`)
        .classList.add('disabled');
}
